import { Row } from "style/preset"
import StyledContainer from "style/styledContainer"
import styled, { css } from "styled-components"


import {ReactComponent as SwapSvg } from 'assets/svgs/icn_swap.svg'
import {ReactComponent as MinimumSvg } from 'assets/svgs/icn_minimum.svg'
import {ReactComponent as GasSvg } from 'assets/svgs/icn_gas.svg'
import {ReactComponent as SlippageSvg } from 'assets/svgs/icn_slippage.svg'
import SlippageWarnCom from "./SlippageWarnCom"
import { useAppSelector } from "hooks/redux/hooks"
import useSwapRate from "hooks/useSwapRate"
import useIsCrossChain from "hooks/useIsCrossChain"

const TransferInfoCom = () => {
    const { fromToken, toToken, gas, slippage, miniToAmount} = useAppSelector((state) => state.coreInfo)
    const { swapRate, chaingeDirection } = useSwapRate()
    const { isCrossChain } = useIsCrossChain()

    return <TransferInfoWrap>
        <InfoWrap>
            <InfoLeftWrap>
                <SwapSvgWrap></SwapSvgWrap>
                <InfoLabelWrap>Swap rate</InfoLabelWrap>
            </InfoLeftWrap>
            <InfoRightWrap $pointer onClick={chaingeDirection}>{swapRate}</InfoRightWrap>
        </InfoWrap>
        {
            !isCrossChain && <InfoWrap>
                <InfoLeftWrap>
                    <MinimumSvgWrap></MinimumSvgWrap>
                    <InfoLabelWrap>Minimum to receive</InfoLabelWrap>
                </InfoLeftWrap>
                <InfoRightWrap>{miniToAmount} {toToken?.symbol}</InfoRightWrap>
            </InfoWrap>
        }
        <InfoWrap>
            <InfoLeftWrap>
                <GasSvgWrap></GasSvgWrap>
                <InfoLabelWrap>Estimated gas</InfoLabelWrap>
            </InfoLeftWrap>
            <InfoRightWrap>{gas} {isCrossChain ? toToken?.symbol : 'USDT'}</InfoRightWrap>
        </InfoWrap>
        <InfoWrap>
            <InfoLeftWrap $isSlippage={slippage >= 20}>
                <SlippageSvgWrap></SlippageSvgWrap>
                <InfoLabelWrap>Estimated slippage</InfoLabelWrap>
            </InfoLeftWrap>
            <InfoRightWrap>
                <SlippageWarnCom></SlippageWarnCom>
            </InfoRightWrap>
        </InfoWrap>
    </TransferInfoWrap>
}

const TransferInfoWrap = styled(StyledContainer)`
    
`

const InfoWrap = styled(Row)`
    justify-content: space-between;
    padding: 10px 0;
    margin-bottom: 6px;

    border-bottom: 1px solid #F2F2F2;
`

const InfoLabelWrap = styled(StyledContainer)`
    font-family: RoobertRegular;
    font-size: 12px;
    font-weight: 400;
    line-height: 14px;
    color: ${({theme}) => theme.lightBlack};
`

const InfoRightWrap = styled(StyledContainer)`
    font-size: 12px;
    font-weight: 500;
    line-height: 14px; 
`

const SvgStyle = () => {
    return css`
        width: 16px;
        height: 16px;
        margin-right: 8px;
    `
}

const SwapSvgWrap = styled(SwapSvg)`
    ${SvgStyle()}
`

const MinimumSvgWrap = styled(MinimumSvg)`
    ${SvgStyle()}
`

const GasSvgWrap = styled(GasSvg)`
    ${SvgStyle()}
`

const SlippageSvgWrap = styled(SlippageSvg)`
    ${SvgStyle()}
`

const InfoLeftWrap = styled(Row)<{$isSlippage: boolean}>`
    ${
       ({$isSlippage, theme}) => $isSlippage ? css`
            ${InfoLabelWrap} {
                color: #E000E0;
            }
            ${SlippageSvgWrap} {
                rect, path {
                    fill: #E000E0;
                }
            }
       ` : ''
    }
`

export default TransferInfoCom